module.exports = __webpack_public_path__ + "static/media/checkMarkPhaseTwo.53e76e02.png";